export default "__VITE_ASSET__0f28efaa__"